







































import { Component, Mixins } from 'vue-property-decorator';
import IdentityData from '@/ts/IdentityData';
import { Actions, Mutations } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import FullScreenLoader from '../../components/Loaders/FullScreenLoader.vue';
@Component(
    {
        components: {
            FullScreenLoader
        }
    }
)
export default class IdentitiesChoose extends Mixins(DeviceMethods) {
    constructor() {
        super();
    }

    public isLoading: boolean = true;

    get identities(): IdentityData[] {
        const allIdentities = this.$store.getters['Identities/getIdentities'];

        if (this.desktopLayout) {
            return allIdentities.filter((identity: IdentityData) => identity.userType === 'staff');
        }

        return allIdentities;
    }

    public selectIdentity(identity: IdentityData) {
        this.$store.dispatch(Actions.SELECT_IDENTITY, {identity, vue: this });
    }

    private async setUserLanguage(state: any) {
        if (state && state.User) {
            const language = state.User.selectedLanguage;
            if (language) {
                await this.$store.dispatch(Actions.SET_LANGUAGE, {language , vue: this});
            }
        }
    }

    public async beforeCreate() {
        const state = await this.$store.state;
        await this.setUserLanguage(state);
        this.isLoading = false;
    }

    public mounted() {
        if (!this.identities.length) {
            this.$router.push({name: 'landing'});
        }
    }
}
